module.exports = __webpack_public_path__ + "static/media/most-red-cards-season.70babab9.png";